import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1559.23847,1559.23847 C1889.69851,1228.77843 1889.69851,691.221573 1559.23847,360.761532 C1228.77843,30.3014919 691.221573,30.3014919 360.761532,360.761532 C30.3014919,691.221573 30.3014919,1228.77843 360.761532,1559.23847 C691.221573,1889.69851 1228.77843,1889.69851 1559.23847,1559.23847 Z M280.86307,280.86307 C655.347163,-93.6210233 1264.65284,-93.6210233 1639.13693,280.86307 C2013.62102,655.347163 2013.62102,1264.65284 1639.13693,1639.13693 C1264.65284,2013.62102 655.347163,2013.62102 280.86307,1639.13693 C-93.6210233,1264.65284 -93.6210233,655.347163 280.86307,280.86307 Z M640.406151,880.101538 L560.507688,800.203075 L960,400.710763 L1359.49231,800.203075 L1279.59385,880.101538 L1016.48821,616.995901 L1016.56811,1439.39077 L903.431889,1439.39077 L903.511787,616.995901 L640.406151,880.101538 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconCircleArrowUpLine = /*#__PURE__*/function (_Component) {
  _inherits(IconCircleArrowUpLine, _Component);

  var _super = _createSuper(IconCircleArrowUpLine);

  function IconCircleArrowUpLine() {
    _classCallCheck(this, IconCircleArrowUpLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconCircleArrowUpLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconCircleArrowUp",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconCircleArrowUpLine.displayName = "IconCircleArrowUpLine";
  return IconCircleArrowUpLine;
}(Component);

IconCircleArrowUpLine.glyphName = 'circle-arrow-up';
IconCircleArrowUpLine.variant = 'Line';
IconCircleArrowUpLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconCircleArrowUpLine;
export { IconCircleArrowUpLine };